import { render, staticRenderFns } from "./thesisServices.vue?vue&type=template&id=6af7fabc&scoped=true"
import script from "./thesisServices.vue?vue&type=script&lang=js"
export * from "./thesisServices.vue?vue&type=script&lang=js"
import style0 from "./thesisServices.vue?vue&type=style&index=0&id=6af7fabc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af7fabc",
  null
  
)

export default component.exports